exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#description {\n  height: 200px !important;\n}\n.ql-editor {\n  height: 200px !important;\n  font-size: 14px !important;\n  font-family: inherit !important;\n}", ""]);

// exports
